export const LAYOUT_BREAKPOINTS = Object.freeze({
  INVOICE_VISIBLE_MAX_WIDTH: 992,
  INVOICE_MD_VISIBLE_MAX_WIDTH: 1200,
});
